export default __webpack_public_path__ + "static/media/adn1.ab4ee01e.png";